import React, { FC } from "react";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import { useCancelApplicationMutation, useGenerateLicenceMutation } from "../../api/beachApi";
import { Dialog } from "primereact/dialog";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectSomethingState, setData } from "../../slices/tmpPatternSlice";
import TextInput from "../../components/form/TextInput";
import { Image } from "primereact/image";

const Actions: FC<{ row: any }> = ({ row }) => {
  const [visible, setVisible] = React.useState(false);
  const [visiblePreview, setVisiblePreview] = React.useState(false);
  const [generateLicence, {isLoading: generateLicenceIsLoading}] = useGenerateLicenceMutation();
  const [cancelApplication] = useCancelApplicationMutation();

  const dispatch = useAppDispatch();
  const { cancelReason } = useAppSelector(selectSomethingState);

  const clearCancelReasonValue = () => {
    dispatch(setData({ property: "cancelReason", value: "" }));
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <Button icon={PrimeIcons.IMAGE} severity="warning" title="Podgląd zdjęcia" tooltip="Podgląd zdjęcia" tooltipOptions={{position: "left"}}
                onClick={() => setVisiblePreview(true)} />
        <Dialog
          visible={visiblePreview}
          onHide={() => {
            setVisiblePreview(false);
          }}
        >
          <Image src={`/api/images-preview/${row.imagePath}`} width="300px" />
        </Dialog>

        <Button icon={PrimeIcons.HISTORY} severity="danger" title="Anuluj" tooltip="Anuluj" tooltipOptions={{position: "left"}}
                onClick={() => setVisible(true)} />
        <Dialog
          visible={visible}
          onHide={() => {
            setVisible(false);
            clearCancelReasonValue();
          }}
          header="Jesteś pewny, że chcesz anulować ten wniosek?"
          footer={
            <Button
              onClick={() => {
                cancelApplication({ id: row.id, cancelApplicationRequest: { cancelReason: cancelReason } });
                setVisible(false);
                clearCancelReasonValue();
              }}
              label="OK"
            />
          }
        >
          <TextInput
            id="cancelReason"
            name="cancelReason"
            label="Powód anulowania"
            value={cancelReason}
            setProperty={setData}
            style={{ width: "100%" }}
            outerStyle={{marginTop: 20}}
          />
        </Dialog>
        <Button
          tooltip="Generuj"
          tooltipOptions={{position: "left"}}
          icon={generateLicenceIsLoading ? PrimeIcons.REFRESH : PrimeIcons.DOWNLOAD}
          onClick={() => generateLicence({ id: row.id })}
        />
      </div>
    </>
  );
};

const approvedListActionTemplate = (row: any) => <Actions row={row} />;
export default approvedListActionTemplate;
